'use client';

import styles from './NotificationsList.module.css';
import { Flex, NotificationItem, NotificationsEmpty } from '@/_components';
import { NotificationsContext } from '@/_contexts/admin/NotificationsProvider/NotificationsProvider';
import { isDownloadLink } from '@/_utils/notifications';
import { type FC, useContext } from 'react';
import { useRouter } from 'next/navigation';
import type { NotificationsListProps } from './NotificationsList.types';

export const NotificationsList: FC<NotificationsListProps> = ({
  notifications,
}) => {
  const { dismissNotificationItem } = useContext(NotificationsContext);
  const { push } = useRouter();

  if (!notifications?.length) return <NotificationsEmpty />;

  return (
    <Flex isColumn={true} gap="px" className={styles.notificationsList}>
      {notifications.map((notification, key) => {
        const link = notification?.link || '';
        const isLinkDownloadable = isDownloadLink(link);

        const onNotificationClick = () => {
          if (link && !isLinkDownloadable) {
            push(link);
          }

          dismissNotificationItem(notification.id);
        };

        return (
          <Flex key={key} className={styles.notificationLine}>
            <NotificationItem
              onClick={onNotificationClick}
              notification={notification}
            />
          </Flex>
        );
      })}
    </Flex>
  );
};
